import { useTranslation } from "react-i18next";

import { useFaq } from "../../../hooks";

import { Container } from "../../../components";
import { SectionTitle } from "../../ui/SectionTitle/SectionTitle";
import { FaqAccordion } from "../FaqAccordion/FaqAccordion";

import { Section } from "../Section/Section.styled";

export const Faq = ({ sectionType }) => {
  const { faqItems } = useFaq();
  const { t } = useTranslation();

  if (!faqItems || faqItems.length === 0) {
    return null;
  }

  return (
    <Section variant={sectionType}>
      <Container>
        <SectionTitle title={t("global.faqTitle")} />
        <FaqAccordion faqData={faqItems} />
      </Container>
    </Section>
  );
};
